import { BaseService } from 'core/services';
import PersonRouteService from './PersonRouteService';

class PersonService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new PersonRouteService());
    }

    async getByUser(userId) {
        const url = this.routeService.getByUser(userId);

        try {
            const result = await this.apiClient.get(url);

            return result;
        }
        catch {
            return null;
        }
    }
}

export default PersonService;
